import styled from "styled-components";

export const Container = styled.img`
  width: auto;
  height: auto;
  max-width: 50px;
  max-height: 50px;
`;
